import * as React from 'react'
import { Switch } from 'react-native-paper'
import {
  StyleProp,
  TextStyle,
  View,
  Text,
  ViewStyle,
  StyleSheet,
  ActivityIndicator,
} from 'react-native'
import { useTheme } from '../../hooks/theme.hook'
import { IconSource } from 'react-native-paper/lib/typescript/components/Icon'
import { Icon } from '../typo/icon'

interface LabeledSwitchProps extends React.ComponentProps<typeof Switch> {
  label: string
  isLoading?: boolean
  onLabelPress?: () => void
  wrapperStyle?: StyleProp<ViewStyle>
  labelStyle?: StyleProp<TextStyle>
  icon?: IconSource
}

export function LabeledSwitch(props: LabeledSwitchProps) {
  const theme = useTheme()
  const styles = StyleSheet.create({
    wrapper: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
    },
    label: {
      marginRight: 10,
      color: theme.colors.text,
      fontSize: theme.fonts.labelLarge.fontSize,
    },
  })
  const { wrapperStyle, label, labelStyle, ...rest } = props
  return (
    <View style={[styles.wrapper, wrapperStyle]}>
      {props.icon && <Icon source={props.icon} size={24} />}

      <Text
        style={[styles.label, labelStyle]}
        onPress={() => props.onLabelPress?.()}
      >
        {label}
      </Text>
      {!props.isLoading ? (
        <Switch {...rest} />
      ) : (
        <ActivityIndicator size="small" color={theme.colors.primary} />
      )}
    </View>
  )
}
